var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4592 3.15143L10.6113 7.99984L15.4592 12.848C16.1803 13.5694 16.1803 14.7379 15.4592 15.4593C15.0989 15.8196 14.6265 15.9999 14.1544 15.9999C13.6814 15.9999 13.209 15.8199 12.849 15.4593L8.00002 10.6106L3.15143 15.4593C2.79118 15.8196 2.31876 15.9999 1.8462 15.9999C1.37378 15.9999 0.901676 15.8198 0.541102 15.4593C-0.18 14.7382 -0.18 13.5696 0.541102 12.848L5.38887 7.99979L0.540827 3.15143C-0.180276 2.43033 -0.180276 1.26152 0.540827 0.540413C1.26179 -0.180138 2.42991 -0.180138 3.15115 0.540413L7.99998 5.38882L12.8484 0.540413C13.5698 -0.180138 14.7381 -0.180138 15.4589 0.540413C16.1803 1.26152 16.1803 2.43033 15.4592 3.15143Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.0bf4437ae62804671f3e43c15de046d3.svg";
export { ForwardRef as ReactComponent };